import React, { useState } from 'react'
import { css } from '@emotion/core'
import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'

// constants
import { headerBarLeftWrapperStyle } from '@/constants/layout'

// components
import { Button } from '@/components/atoms/button'
import { CSVReader } from '@/components/organisms/csv-reader'
import { Popup } from '@/components/atoms/popup'

const parseOptions = {
  header: true,
  skipEmptyLines: true,
}

type ContainerProps = {
  csvData: string[][]
  onFileLoad: (data: any) => void
  onClickAddButton: () => void
  canEdit: boolean
}

type Props = {}

// @todo organismsなりに移動すること
export const SettingSalesSubjectEditButtons: React.FC<ContainerProps & Props> = ({ csvData, onFileLoad, onClickAddButton, canEdit }) => {
  const { t } = useTranslation()
  const [isDropDownOpen, setIsDropDownOpen] = useState<boolean>(false)

  return (
    <div css={editButtonWrapperStyle}>
      <div css={headerBarLeftWrapperStyle}>
        <Button
          buttonType={canEdit ? 1 : 5}
          width={107}
          height={32}
          marginRight={16}
          fontSize={12}
          icon={require('@/static/images/mobile_request/add.svg')}
          isDisabled={!canEdit}
          onClick={() => onClickAddButton()}
        >
          {t('Add new')}
        </Button>
      </div>
      <div style={{ position: 'relative' }}>
        <Button
          buttonType={4}
          width={100}
          height={32}
          fontSize={12}
          icon={require('@/static/images/csv.svg')}
          onClick={() => setIsDropDownOpen(!isDropDownOpen)}
        >
          {t('CSV')} <img src={require('@/static/images/select_gray.svg')} css={dropDownIcon} />
        </Button>
        <Popup isOpen={isDropDownOpen} onClose={() => setIsDropDownOpen(false)} customStyle={css({ width: 153, right: 0, top: 32 })}>
          <ul>
            {canEdit && (
              <li css={dropDownContentStyle}>
                <CSVReader
                  inputStyle={{ display: 'none', cursor: 'pointer' }}
                  label={t('Upload')}
                  parserOptions={parseOptions}
                  onFileLoaded={data => {
                    onFileLoad(data)
                    setIsDropDownOpen(false)
                  }}
                />
              </li>
            )}
            <li css={dropDownContentStyle}>
              <CSVLink filename={'sales-subject-set.csv'} data={csvData} onClick={() => setIsDropDownOpen(false)}>
                <p>{t('Download')}</p>
              </CSVLink>
            </li>
          </ul>
        </Popup>
      </div>
    </div>
  )
}

const editButtonWrapperStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '24px 32px 19px',
  backgroundColor: '#fff',
})

const dropDownIcon = css({
  marginLeft: 8,
})

const dropDownContentStyle = css({
  display: 'flex',
  height: 34,
  listStyle: 'none',
  alignItems: 'center',
  padding: '0 16px',
  cursor: 'pointer',
  '&:hover': {
    background: '#f2f2f2',
  },
  'label, p': {
    fontSize: '14px !important',
    color: '#272727',
  },
})
